module.exports = __webpack_public_path__ + "static/media/st.d0a56dbb.svg";